/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import { DateCell } from '@/backgrid/MomentCell';
import ButtonLinkCell from '@/backgrid/ButtonLinkCell';
import FileLinkCell from '@/backgrid/FileLinkCell/FileLinkCell';
import LinkCell from '@/backgrid/LinkCell';
import PageableCollection from '@/backbone/PageableCollection';

const OrderDashboardGridView = GridView.extend({
  className: 'order-dashboard-grid-view horizontal-scroll',

  options: {
    pageSize: 50
  },

  initialize() {
    const status = EXTERNAL ? 'extOrderStatus' : 'orderStatus';
    this.options.columns = [
      {
        name: 'orderID',
        label: 'Order ID',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 10 : 7,
        editable: false
      },
      {
        name: 'customerName',
        label: 'Customer',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'commandName',
        label: 'Command',
        cell: LinkCell.extend({
          name() {
            return this.model.get('commandName');
          },
          href(model) {
            return `#command/${model.get('commandId')}`;
          },
          newTab: true
        }),
        headerCell: 'custom',
        width: 10,
        editable: false,
        renderable: !EXTERNAL
      },
      {
        name: 'orderType',
        label: 'Order Type',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 18 : 10,
        editable: false
      },
      {
        name: status,
        label: 'Status',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 10 : 7,
        editable: false
      },
      {
        name: 'trackerNumber',
        label: 'Tracker #',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 10 : 8,
        editable: false
      },
      {
        name: 'orderPackageID',
        label: 'Order Package ID',
        cell: LinkCell.extend({
          name() {
            return this.model.get('orderPackageID');
          },
          href(model) {
            return `#order-package/${model.get('orderPackageID')}`;
          },
          newTab: true
        }),
        headerCell: 'custom',
        width: 8,
        editable: false,
        renderable: !EXTERNAL
      },
      {
        name: 'regionName',
        label: 'Location',
        cell: StringCell,
        headerCell: 'custom',
        width: EXTERNAL ? 12 : 7,
        editable: false
      },
      {
        name: 'assignedCRS',
        label: 'Assigned CRS',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'popStartDate',
        label: 'POP Start Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 8,
        editable: false,
        renderable: !EXTERNAL
      },
      {
        name: 'submittedOn',
        label: 'Submitted On',
        cell: DateCell,
        headerCell: 'custom',
        width: EXTERNAL ? 10 : 8,
        editable: false
      },
      {
        name: 'customerResponsibilitiesDocument',
        label: 'Customer Acknowledgment',
        width: 30,
        headerCell: 'custom',
        editable: false,
        sortable: false,
        renderable: EXTERNAL,
        cell: FileLinkCell
      },
      {
        name: 'openButton',
        label: '',
        width: 5,
        headerCell: 'custom',
        editable: false,
        sortable: false,
        cell: ButtonLinkCell.extend({
          name: 'Open',
          href(model) {
            return `#order/${model.get('orderID')}`;
          },
          buttonClass(model) {
            return !EXTERNAL && model.get('orderStatus') === 'CRS Pending Assignment'
              ? 'd-none'
              : 'btn-sm btn-outline-primary';
          },
          newTab: true
        })
      }
    ];
    this.collection = new PageableCollection([], {
      pageSize: this.options.pageSize
    });
    this.options.emptyText = 'No Orders Found';
    this.options.width = '2500px';
    GridView.prototype.initialize?.apply(this, this.options);
  }
});
export default OrderDashboardGridView;
